import ModalComponent from '../../../core/common/modal/ModalComponent'
import React, { useEffect, useState } from 'react';
import { Form, Button, Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Select, { StylesConfig } from "react-select";
import { useGetAssignmentDetailByIdQuery, useGetCreateUserLookupQuery,useUpsertProjectAssignmentDetailsMutation, useGetSystemSuggestionDetailsQuery, useLazyGetAssignmentDetailByIdQuery, useLazyGetEnterpriseMemberByNameQuery, useLazyGetEnterpriseMemberByRoleQuery, useLazyGetTeamMemberByNameQuery, useLazyGetTeamMemberByRoleQuery, useLazyTeamDetailsInProjectQuery, useGetProjectLookupsQuery } from '../../../services/EndPointsApis';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import TextField from '../../../core/common/textFields/TextField';

const PdmAssignModalProject =({show,handleClose,projectRecordNumber, refetchAssignments, BusinessUnitValue,selectedIndividualCheckboxId, isEditing }: any) => {
    
  const projectId=selectedIndividualCheckboxId[0];  
  const customStyles: StylesConfig = {
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? "rgba(177, 31, 40, 1)" : "#fff",
      color: state.isFocused ? "#fff" : "#000",
      "&:hover": {
        backgroundColor: "rgba(177, 31, 40, 1)",
      },
    }),
    menuPortal: base => ({ ...base, zIndex: 9999 })
  };
  
  const [activeStep, setActiveStep] = useState(0);
  const [selectedList, setselectedList] = useState([])
  const [selectedFormatBusiness, setSelectedFormatBusiness] = useState('Name(Role)');
  const [selectedFormat, setSelectedFormat] = useState('Name(Role)');

  const [dropdownOpen, setDropdownOpen] = useState(true);

  //Teams Lookup
  const { data: usersLookup } = useGetCreateUserLookupQuery('');//lookups users
  //Get teams Details By Id
  const [triggerTeamDetails, { data: teamsDetails }] = useLazyTeamDetailsInProjectQuery();
  //teams BY Name
  const [triggerTeamsByName, { data: teamsByName }] = useLazyGetTeamMemberByNameQuery();
  //teams BY Role
  const [triggerTeamsByRole, { data: teamsByRole }] = useLazyGetTeamMemberByRoleQuery();
  //Get System Team Details
  const { data: systemSuggestion,refetch:refetchSystemSuggestions } = useGetSystemSuggestionDetailsQuery('');
  //Create Update Assignment
  const [createAssignment, { data: AssignmentData, isError, error, isSuccess, isLoading }] = useUpsertProjectAssignmentDetailsMutation();
  //teams BY Business Name
  const [triggerTeamsByBusinessName, { data: teamsByBusinessName }] = useLazyGetEnterpriseMemberByNameQuery();
  //teams BY Business Role
  const [triggerTeamsByBusinessRole, { data: teamsByBusinessRole }] = useLazyGetEnterpriseMemberByRoleQuery();
  //Get Assignment Detail BY Id
  const [triggerAssignmentById, { data: assignmentByIdData }] = useLazyGetAssignmentDetailByIdQuery();
//Project Lookup 
const { data: projectLookups, refetch: projectLookupsRefetch } = useGetProjectLookupsQuery('');

const steps = ['1', '2', '3', '4'];
  
  const handleNext = () => {
    if (activeStep < steps.length - 1) {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    } else {
      formik.handleSubmit()
      handleClose();
    }
  };
  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const initialValues = {
    id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    projectId: projectId,
    projectRecNumber:projectRecordNumber,
    systemRegion: "",
    systemSite: "",
    systemTeam: "",
    userRegion: "",
    userSite: "",
    lst_BusinessUnit: {
      id: BusinessUnitValue?.value,
      value: BusinessUnitValue?.label
    },
    lst_UserTeam: {
      id: 0,
      value: ""
    },
    lst_EnterPriseBusinessUnit: {
      id: 0,
      value: ""
    },
    assignTeamsMembersByName: [
      {
        id: 0,
        value: ""
      }
    ],
    assignTeamsMembersByRole: [
      {
        id: 0,
        value: ""
      }
    ],
    assignEntTeamsMembersByName: [
      {
        id: 0,
        value: ""
      }
    ],
    assignEntTeamsMembersByRole: [
      {
        id: 0,
        value: ""
      }
    ]
  }
  const formik = useFormik({
    initialValues,
    // validationSchema: validationSchema,
    onSubmit: (values) => {
      createAssignment(values)
    }
  })
  const { resetForm } = formik;
  const [updatedId, setUpdateId] = useState(null)

  useEffect(() => {
    if (assignmentByIdData?.result && Object.keys(assignmentByIdData?.result).length > 0 && show === true) {
      setUpdateId(assignmentByIdData?.result?.userAccountId);
      formik.setValues({ ...assignmentByIdData?.result });  
    } else {
      setUpdateId(null);
      // resetForm();
    }
  }, [assignmentByIdData,show]);

  useEffect(() => {

    formik.setFieldValue("systemRegion", systemSuggestion?.result?.systemRegion);
    formik.setFieldValue("systemTeam", systemSuggestion?.result?.systemTeam);
    formik.setFieldValue("systemSite", systemSuggestion?.result?.systemSite);
  }, [systemSuggestion?.result, updatedId]);

  useEffect(() => {
    if(teamsDetails){
      formik.setFieldValue("userRegion", teamsDetails?.result?.userRegion);
      formik.setFieldValue("userSite", teamsDetails?.result?.userSite);
    }
  }, [teamsDetails?.result, updatedId]);

  useEffect(() => {
    if (show === true) {
      refetchSystemSuggestions()
      triggerAssignmentById({ projectId: projectId})
    }
    
  }, [show])

  useEffect(() => {

    if (show === true && assignmentByIdData?.result?.lst_EnterPriseBusinessUnit.id !== null ) {
        triggerTeamsByBusinessName({ businessUnitId: assignmentByIdData?.result?.lst_EnterPriseBusinessUnit.id })
        triggerTeamsByBusinessRole({ businessUnitId: assignmentByIdData?.result?.lst_EnterPriseBusinessUnit.id})
    }
    if (show === true &&  assignmentByIdData?.result?.lst_UserTeam.id !== null ) {
        triggerTeamsByName({ teamID: assignmentByIdData?.result?.lst_UserTeam.id })
        triggerTeamsByRole({ teamID: assignmentByIdData?.result?.lst_UserTeam.id})
    }
  }, [assignmentByIdData])
  
  useEffect(() => {
    if (isSuccess) {
      toast.success(AssignmentData?.message);
      handleClose();
      resetForm()
      setActiveStep(0)
      refetchAssignments()
    }
    // if (isEdit && isSuccess) {
    //   toast.success('User Updated Successfully');
    //   handleClose();
    //   refetch()
    // }
  }, [isSuccess]);

  useEffect(() => {
    if (isError && error) {
      let errorMessage: string = 'Something went wrong';

      if ('data' in error && error.data && typeof error.data === 'object' && 'message' in error.data) {
        errorMessage = (error.data as { message: string }).message;
      }
      toast.error(errorMessage);
      resetForm()
    }
  },
    [isError, error]);
  const handleRadioChange = (event: any) => {
    setSelectedFormat(event.target.value);
  };
  const handleRadioChangeBusiness = (event: any) => {
    setSelectedFormatBusiness(event.target.value);
  };

  const optionsTeam = selectedFormat === 'Name(Role)'
    ? teamsByName?.result?.map((option: any) => ({
      label: option?.value,
      value: option?.id
    })) || []
    : teamsByRole?.result?.map((option: any) => ({
      label: option?.value,
      value: option?.id
    })) || [];

  const optionsBusinesTeam = selectedFormatBusiness === 'Name(Role)'
    ? teamsByBusinessName?.result?.map((option: any) => ({
      label: option?.value,
      value: option?.id
    })) || []
    : teamsByBusinessRole?.result?.map((option: any) => ({
      label: option?.value,
      value: option?.id
    })) || [];

  type TeamOption = {
    id: number;
    value: string;
  };
  const handleChangeTeam = (newValue: any) => {
    const updatedValues: TeamOption[] = newValue.map((option: { value: any; label: any }) => ({
      id: option.value,
      value: option.label
    }));

    if (selectedFormat === 'Name(Role)') {
      formik.setFieldValue('assignTeamsMembersByName', updatedValues);
    } else if (selectedFormat === 'Role(Name)') {
      formik.setFieldValue('assignTeamsMembersByRole', updatedValues);
    }
  };

  const handleChangeTeamBusiness = (newValue: any) => {
    const updatedValues: TeamOption[] = newValue.map((option: { value: any; label: any }) => ({
      id: option.value,
      value: option.label
    }));
    if (selectedFormatBusiness === 'Name(Role)') {
      formik.setFieldValue('assignEntTeamsMembersByName', updatedValues);
      
    } else if (selectedFormatBusiness === 'Role(Name)') {
      formik.setFieldValue('assignEntTeamsMembersByRole', updatedValues);
    }

  };

  const selectValuesTeam = selectedFormat === 'Name(Role)'
    ? (formik.values.assignTeamsMembersByName || [])
      .filter((team: { id: number; value: string }) => team.id !== 0 && team.value !== '')
      .map((team: { id: number; value: string }) => ({
        value: team.id,
        label: team.value,
      }))
    : (formik.values.assignTeamsMembersByRole || [])
      .filter((team: { id: number; value: string }) => team.id !== 0 && team.value !== '')
      .map((team: { id: number; value: string }) => ({
        value: team.id,
        label: team.value,
      }));
  const selectValuesTeamBusiness = selectedFormatBusiness === 'Name(Role)'
    ? (formik.values.assignEntTeamsMembersByName || [])
      .filter((team: { id: number; value: string }) => team.id !== 0 && team.value !== '')
      .map((team: { id: number; value: string }) => ({
        value: team.id,
        label: team.value,
      }))
    :  (formik.values.assignEntTeamsMembersByRole || [])
      .filter((team: { id: number; value: string }) => team.id !== 0 && team.value !== '')
      .map((team: { id: number; value: string }) => ({
        value: team.id,
        label: team.value,
      }));
      
  useEffect(() => {
    formik.setFieldValue('lst_BusinessUnit.id', BusinessUnitValue?.value)
    formik.setFieldValue('lst_BusinessUnit.value', BusinessUnitValue?.label)
  }, [show])

  useEffect(() => {
    if (handleClose) {
      setActiveStep(0)
    }
  }, [handleClose])

  const Step1: React.FC = () => (
    <div className='mt-3 mb-3'>
      <h4 className='mb-3'> Choose Team</h4>
      <p>By default the system given team is selected, unless user defines a different team.</p>
      <h6 className='mb-3'>System suggested Divisions:</h6>
      <div className='row overflow-auto'>
        <div className="col-md-4 mt-3">
          <label className="input-label">
            Region<span className="text-danger"> *</span>
          </label>
          <TextField
            value={formik?.values?.systemRegion}
            disabled
          />
        </div>
        <div className="col-md-4 mt-3">
          <label className="input-label">
            Site<span className="text-danger"> *</span>
          </label>
          <TextField
            value={formik?.values?.systemSite}
            disabled
          />
        </div>
        <div className="col-md-4 mt-3">
          <label className="input-label">
            Team<span className="text-danger"> *</span>
          </label>
          <TextField
            value={formik?.values?.systemTeam}
            disabled
          />
        </div>
        <h6 className='mb-2 mt-3'>User suggested Divisions:</h6>
        <div className="col-md-4 mt-3">
          <label className="input-label">
            Region<span className="text-danger"> *</span>
          </label>
          <TextField
            value={formik.values.userRegion}
            disabled
          />
        </div>
        <div className="col-md-4 mt-3">
          <label className="input-label">
            Site<span className="text-danger"> *</span>
          </label>
          <TextField
            value={formik.values.userSite}
            disabled
          />
        </div>
        {/* <div className="col-md-4 mt-3">
          <label className="input-label">
            Team<span className="text-danger"> *</span>
          </label>
          <TextField
            value={formik.values.teamName}
            disabled
          />
        </div> */}
        <div className="col-md-12 mt-3">
          <label className="input-label">
            Assign following division to a project:<span className="text-danger"> *</span>
          </label>
          <Select
            styles={customStyles}
            menuPortalTarget={document.body}
            options={usersLookup?.result?.teamList?.map((option: any) => ({
              label: option?.name,
              value: option?.id
            })) || null}
            value={
              formik.values?.lst_UserTeam?.id
                ? {
                  value: formik.values?.lst_UserTeam?.id,
                  label: formik.values?.lst_UserTeam?.value || '',
                }
                : []
            }
            className="select"
            onChange={(selectedOption: any) => {
              triggerTeamDetails({ teamID: selectedOption.value })
              triggerTeamsByName({ teamID: selectedOption.value })
              triggerTeamsByRole({ teamID: selectedOption.value })
              formik.setFieldValue("lst_UserTeam.id", selectedOption.value);
              formik.setFieldValue("lst_UserTeam.value", selectedOption.label);
            }}

          // isDisabled={isReadOnly}
          />
        </div>
        <div className="col-md-4 mt-3">
          <label className="input-label">
            Project ID<span className="text-danger"> *</span>
          </label>
          <input type="text" className="form-control" placeholder=""
            value={formik.values.projectRecNumber||projectRecordNumber}
            disabled
          />
        </div>
      </div>
    </div>
  );

  const Step2: React.FC = () => (
    <div className='mt-3 mb-3'>
      <h4 className='mb-2'> Assign Members</h4>
      <p className='mb-3'>Please Choose members of Primary team.</p>
      <div className='row'>
        <div className='col-md-6'>
          <div className='d-flex gap-3 '>
            <p>Format:</p>
            <div>
              <input
                type="radio"
                className="status-radio"
                id="active"
                name="format"
                value="Name(Role)"
                checked={selectedFormat === 'Name(Role)'}
                onChange={handleRadioChange}
              />
              <label htmlFor="active">Name(Role)</label>
            </div>
            <div>
              <input
                type="radio"
                className="status-radio"
                id="active1"
                name="format"
                value="Role(Name)"
                checked={selectedFormat === 'Role(Name)'}
                onChange={handleRadioChange}
              />
              <label htmlFor="active1">Role(Name)</label>
            </div>
          </div>
        </div>
        <div className='col-md-12'>
          <label className="input-label">
            Team Members: Classic <span className="text-danger">*</span>
          </label>
          {/* <Select className='select' isMulti={true}  options={selectValues} />  */}
          <Select className='select'
            styles={customStyles}
            options={optionsTeam}
            isMulti={true}
            value={
              selectValuesTeam
            }
            onChange={(selectedList: any) => {
              handleChangeTeam(selectedList);
            }}
          />
        </div>
      </div>
    </div>
  );

  const Step3: React.FC = () => (
    <div className='mt-3 mb-3'>
      <h4 className='mb-2'> Assign Enterprise Members</h4>
      <p className='mb-3'>Please choose enterprise wide team members.</p>
      <div className='row'>
        <div className='col-md-12'>
          <label className="input-label">
            Business Unit <span className="text-danger">*</span>
          </label>
          {/* <Select className='select' isMulti={true}  options={selectValues} />  */}
          <Select className='select'
            styles={customStyles}
            options={projectLookups?.result?.Lst_BusinessUnit?.map((option: any) => ({
              label: option?.value,
              value: option?.id
            })) || null}
            value={
              formik.values?.lst_EnterPriseBusinessUnit?.id
                ? {
                  value: formik.values?.lst_EnterPriseBusinessUnit?.id,
                  label: formik.values?.lst_EnterPriseBusinessUnit?.value || '',
                }
                : null
            }
            onChange={(selectedOption: any) => {
              triggerTeamsByBusinessName({ businessUnitId: selectedOption.value })
              triggerTeamsByBusinessRole({ businessUnitId: selectedOption.value })
              formik.setFieldValue("lst_EnterPriseBusinessUnit.id", selectedOption.value);
              formik.setFieldValue("lst_EnterPriseBusinessUnit.value", selectedOption.label);
            }}
          />

        </div>
        <div className='col-md-6 mt-3'>
          <div className='d-flex gap-3 '>
            <p>Format:</p>
            <div>
              <input
                type="radio"
                className="status-radio"
                id="activeBusniess"
                name="formatBusiness"
                value="Name(Role)"
                checked={selectedFormatBusiness === 'Name(Role)'}
                onChange={handleRadioChangeBusiness}
              />
              <label htmlFor="activeBusniess">Name(Role)</label>
            </div>
            <div>
              <input
                type="radio"
                className="status-radio"
                id="activeBusiness1"
                name="formatBusiness"
                value="Role(Name)"
                checked={selectedFormatBusiness === 'Role(Name)'}
                onChange={handleRadioChangeBusiness}
              />
              <label htmlFor="activeBusiness1">Role(Name)</label>
            </div>
          </div>
        </div>
        <div className='col-md-12'>
          <label className="input-label">
            Team Members: <span className="text-danger">*</span>
          </label>
          {/* <Select className='select' isMulti={true}  options={selectValues} />  */}
          <Select className='select'
            styles={customStyles}
            options={optionsBusinesTeam}
            isMulti={true}
            value={
              selectValuesTeamBusiness
            }
            onChange={(selectedList: any) => {
              handleChangeTeamBusiness(selectedList);
            }}
          />

        </div>
      </div>
    </div>
  );

  const Step4: React.FC = () => (
    <div className='row'>
      <div className='col-md-12'>
        <h4 className='mt-3 mb-3'>
          Project Info
        </h4>
        <p className=''>Click Save to post information to AFD and send confirmation email OR Cancel to abort changes.</p>
      </div>
      <div className="col-md-12 mt-3">
        <label className="input-label">
          Project ID<span className="text-danger"> *</span>
        </label>
        <input type="text" className="form-control" placeholder=""
          value={formik.values.projectRecNumber}
          disabled
        />
      </div>
      <div className="col-md-12 mt-3">
        <label className="input-label">
          Project Team Added<span className="text-danger"> *</span>
        </label>
        <input type="text" className="form-control" placeholder=""
          value={formik.values.lst_UserTeam?.value}
          disabled
        />
      </div>
    </div>
  );

  const getStepContent = (stepIndex: number) => {

    switch (stepIndex) {
      case 0:
        return <Step1 />;
      case 1:
        return <Step2 />
      case 2:
        return <Step3 />
      case 3:
        return <Step4 />;
      default:
        return 'Unknown stepIndex';
    }
  };
  
  return (
  //   <ModalComponent
  //   modalTitle='Saving Current Filters'
  //   isVisible={show}
  //   cancelButton="Cancel"
  //   onClose={handleClose}
  //   saveButton='Save'
  //   className="p-2"

  // >
    <>
    <div className={show ? "toggle-popup sidebar-popup" : "toggle-popup"}>
        <div className="sidebar-layout">
          <div className="sidebar-header d-flex justify-content-end">
            {/* <h4>{isEditing ? `Edit ${BusinessUnitValue?.label}` : `${BusinessUnitValue?.label}`} </h4> */}
            <Link to="#" className="sidebar-close toggle-btn" onClick={handleClose}>
              <i className="ti ti-x" />
            </Link>
          </div>

          <div className="toggle-body">
            <div className="toggle-height">
              <form onSubmit={formik.handleSubmit}>
                <div className="pro-create">
                  <Row>
                    <Col>
                      <div className="stepper">
                        <ul className="list-inline d-flex justify-content-between">
                          {steps.map((label, index) => (
                            <React.Fragment key={label}>

                              <li className={`list-inline-item ${activeStep === index ? 'active' : index < activeStep ? 'completed' : ''}`}>
                                {label}
                              </li>

                              {index < steps.length - 1 && ( // Render <hr> except after the last item
                                <li className='w-130'>
                                  <hr style={{ height: "2px", width: "100%" }} />
                                </li>
                              )}

                            </React.Fragment>
                          ))}
                        </ul>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      {getStepContent(activeStep)}
                    </Col>
                  </Row>
                </div>
              </form>

              <div className="submit-button text-end">
                <button
                  className="btn btn-light"
                  disabled={activeStep === 0}
                  onClick={handleBack}
                >
                  Back
                </button>
                <button
                  className='btn btn-primary'
                  onClick={handleNext}>
                  {activeStep === steps.length - 1 ? 'Save' : 'Next'}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>

  // </ModalComponent>
  )
}

export default PdmAssignModalProject